export const downloadTextFile = (text: any, filename: string, extension: string, dataType: string) => {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([text], {type: dataType}));
    a.download = `${filename}.${extension}`;
    a.click();

}
